import _get from "lodash.get";

import { StaticImage } from "gatsby-plugin-image";
import React from "react";

export const getProductName = code => {
  switch (code) {
    case "laroca":
      return "products.larocaTitle";
    case "fidonisi":
      return "products.fidonisiTitle";
    case "vrasidas":
      return "products.vrasidasTitle";
    case "elies":
      return "products.eliesTitle";
    case "allday":
      return "products.alldayTitle";
    case "fishing":
      return "products.fishingTitle";
    case "group":
      return "products.groupTitle";
    case "admin":
      return "products.adminTitle";
    default:
      return null;
  }
};

export const getProductImage = (code, t) => {
  const images = {
    laroca: (
      <StaticImage
        src="../../static/images/product/laroca.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["WEBP", "AVIF"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={34}
        fetchpriority="high"
      />
    ),
    fidonisi: (
      <StaticImage
        src="../../static/images/product/fidonisi.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={35}
        fetchpriority="high"
      />
    ),
    vrasidas: (
      <StaticImage
        src="../../static/images/product/vrasidas.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={40}
        fetchpriority="high"
      />
    ),
    elies: (
      <StaticImage
        src="../../static/images/product/elies.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={35}
        fetchpriority="high"
      />
    ),
    allday: (
      <StaticImage
        src="../../static/images/product/allday.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={35}
        fetchpriority="high"
      />
    ),
    fishing: (
      <StaticImage
        src="../../static/images/product/fishing.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={406}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={35}
        fetchpriority="high"
      />
    ),
    group: (
      <StaticImage
        src="../../static/images/product/group.jpg"
        alt={t(getProductName(code))}
        loading="eager"
        placeholder="blurred"
        layout="constrained"
        width={812}
        style={{ height: "100%" }}
        sizes="(max-width: 768px) 200px, 406px"
        formats={["AVIF", "WEBP"]}
        breakpoints={[768, 1024, 1216, 1408]}
        quality={45}
        fetchpriority="high"
      />
    )
  };

  return images[code];
};

export const getProductMapImage = (code, t) => {
  const images = {
    laroca: (
      <StaticImage
        src="../images/laroca_map.png"
        loading="eager"
        alt={`${t(getProductName(code))} ${t("helpers.altImageMap")}`}
        placeholder="blurred"
        layout="constrained"
        width={203}
        style={{ height: "100%" }}
        formats={["WEBP", "AVIF"]}
        quality={40}
      />
    ),
    fidonisi: (
      <StaticImage
        src="../images/fidonisi_map.png"
        loading="eager"
        alt={`${t(getProductName(code))} ${t("helpers.altImageMap")}`}
        placeholder="blurred"
        layout="constrained"
        width={203}
        style={{ height: "100%" }}
        formats={["WEBP", "AVIF"]}
        quality={40}
      />
    ),
    vrasidas: (
      <StaticImage
        src="../images/vrasidas_map.png"
        loading="eager"
        alt={`${t(getProductName(code))} ${t("helpers.altImageMap")}`}
        placeholder="blurred"
        layout="constrained"
        width={203}
        style={{ height: "100%" }}
        formats={["WEBP", "AVIF"]}
        quality={40}
      />
    ),
    elies: (
      <StaticImage
        src="../images/elies_map.png"
        loading="eager"
        alt={`${t(getProductName(code))} ${t("helpers.altImageMap")}`}
        placeholder="blurred"
        layout="constrained"
        width={203}
        style={{ height: "100%" }}
        formats={["WEBP", "AVIF"]}
        quality={40}
      />
    ),
    allday: (
      <StaticImage
        src="../images/allday_map.png"
        loading="eager"
        alt={`${t(getProductName(code))} ${t("helpers.altImageMap")}`}
        placeholder="blurred"
        layout="constrained"
        width={203}
        style={{ height: "100%" }}
        formats={["WEBP", "AVIF"]}
        quality={40}
      />
    )
  };

  return images[code];
};

export const round = function (value) {
  return Number(Math.round(value + "e2") + "e-2");
};

export const requestError = err => {
  let errorMessage = "";
  if (_get(err, "response.data")) {
    const data = _get(err, "response.data");
    if (_get(data, "Message")) {
      errorMessage = _get(data, "Message");
    } else if (_get(data, "message")) {
      errorMessage = _get(data, "message");
    } else {
      errorMessage = data;
    }
  } else if (_get(err, "response")) {
    errorMessage = JSON.stringify(err.response);
  } else if (err.request) {
    errorMessage = "The request was made but no response was received";
  } else {
    errorMessage = "Something happened in setting up the request that triggered an Error";
  }
  return errorMessage;
};

export const passengersText = (number, language = "bg") => {
  if (!number) return "";

  switch (language) {
    case "bg":
      switch (number) {
        case 1:
          return "един";
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          return `${number}-ма`;
        default:
          return `${number}`;
      }

    case "en":
      switch (number) {
        case 1:
          return "one";
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          return `${number}-person`;
        default:
          return `${number}`;
      }

    case "el":
      switch (number) {
        case 1:
          return "ένας";
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
          return `${number}-άδες`;
        default:
          return `${number}`;
      }

    default:
      return `${number}`;
  }
};

export const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const mapHtmlEntityIcons = icon => {
  switch (icon) {
    case "beach":
      return "&#x1F3D6;";
    case "boat":
      return "&#x1F6E5;";
    default:
      return "";
  }
};

export const convertHoursToTimeRange = time => {
  switch (time) {
    case "9:00 - 14:00":
    case "10:00 - 14:00":
    case "10:00 - 12:30":
      return "first-half";
    case "14:00 - 18:00":
    case "14:00 - 19:00":
    case "14:00 - 16:30":
      return "second-half";
    case "10:00 - 18:00":
      return "all-day";
    case "7:00 - 12:00":
      return "all-day";
    default:
      return "";
  }
};
export const partOfTheDayLabel = timeТxt => {
  switch (timeТxt) {
    case "all-day":
      return "цял ден";
    case "first-half":
      return "сутрин";
    case "second-half":
      return "следобед";
    default:
      return "";
  }
};
export const capitalizeFirstLetter = string => {
  if (!string) {
    return undefined;
  }
  if (string.length > 1) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  return string.charAt(0).toUpperCase();
};

export const stripLanguagePrefix = url => {
  return url.replace(/^\/(en|el)\//, "/");
};

export const getCookie = name => {
  try {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
  } catch (err) {
    //  console.log(err);
  }
  return null;
};

export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  const env = process.env.NODE_ENV;
  const domains = {
    development: "localhost",
    production: "boat-neaperamos.com"
  };

  document.cookie = `${name}=${encodeURIComponent(value) || ""}${expires}; domain=.${domains[env]}; path=/; SameSite=Strict`;
};
